import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
interface ServiceCardProps {
  name: string;
  price: string;
  features: string[];
  paymentLink?: string;
  image: string;
  popular?: boolean;
}
export function ServiceCard({
  name,
  price,
  features,
  paymentLink,
  image,
  popular
}: ServiceCardProps) {
  return <div className={`bg-white rounded-2xl shadow-lg overflow-hidden ${popular ? 'ring-2 ring-emerald-500' : ''}`} data-id="element-104">
      {popular && <div className="bg-emerald-500 text-white text-center py-2 text-sm font-semibold" data-id="element-105">
          Most Popular
        </div>}

      {/* Image */}
      <div className="h-48 bg-gradient-to-br from-emerald-100 to-teal-100 flex items-center justify-center" data-id="element-106">
        <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-107" />
      </div>

      {/* Content */}
      <div className="p-8" data-id="element-108">
        <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-109">{name}</h3>
        <div className="mb-6" data-id="element-110">
          <span className="text-4xl font-bold text-emerald-600" data-id="element-111">{price}</span>
          <span className="text-slate-600" data-id="element-112">/month</span>
        </div>

        <ul className="space-y-3 mb-8" data-id="element-113">
          {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-114">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-115" />
              <span className="text-slate-700" data-id="element-116">{feature}</span>
            </li>)}
        </ul>

        {paymentLink ? <Button variant="primary" size="lg" href={paymentLink} className="w-full" data-id="element-117">
            Buy Now
          </Button> : <Button variant="outline" size="lg" className="w-full cursor-not-allowed opacity-50" data-id="element-118">
            Coming Soon
          </Button>}
      </div>
    </div>;
}